import { Box, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
            zIndex: 99999,
        },
        line: {
            backgroundColor: theme.palette.primary.main,
            height: 1,
            position: 'absolute',
            top: '30%',
            width: '100%',
            zIndex: 0,
        },
    });
});
export default (function (_a) {
    var children = _a.children, style = _a.style;
    var styles = useStyles({});
    return (React.createElement(Box, { position: "relative", zIndex: "99", style: style },
        React.createElement(Box, { className: styles.line }),
        React.createElement(Box, { maxWidth: 940, margin: "0 auto", width: '100%' },
            React.createElement(Box, { className: styles.container }, children))));
});
//# sourceMappingURL=index.js.map